module.exports = __webpack_public_path__ + "static/media/onboarding-carousel-example2x.7baf461b.png";